module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-down-circle-fill-8c677b57.svg";